const locale = {
  placeholder: 'Ø§ÙØªØ®Ø§Ø¨ Ø²ÙØ§Ù',
};

export default locale;
